import { render, staticRenderFns } from "./billingAddress.vue?vue&type=template&id=3e15e1b2"
import script from "./billingAddress.vue?vue&type=script&lang=js"
export * from "./billingAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Countries: require('/home/ubuntu/containers/hermes_eshop/components/core/countries.vue').default,Field: require('/home/ubuntu/containers/hermes_eshop/components/core/field.vue').default})
